/* eslint-disable max-len */
import React from 'react'

interface Props {
  text: string
}

const SubscriptionProfit = ({ text }: Props): JSX.Element => {
  return (
    <div className="flex justify-start gap-1.5 items-center">
      <div className="w-6 h-6 relative text-Estigroup-primary mt-[3px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
          />
        </svg>
      </div>
      <div className="flex-1 justify-center text-Estigroup-tertiary text-sm font-normal font-['Open Sans'] leading-tight">
        {text}
      </div>
    </div>
  )
}

export default SubscriptionProfit
